export default __webpack_public_path__ + "static/media/interface-12.6befedbb.png";